mutation SupplierApprovalRevoke($input: SupplierApprovalRevokeInput!) {
  supplierApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
